import styled from "styled-components";

export const IndexContainer = styled("div")``;
